module.exports = __webpack_public_path__ + "img/orange.620656e0.svg";